import { useEffect, useState } from "react";

const VISITED_PARLOR_IDS_STORAGE_KEY = "goi_parlor_visited_ids";

function readVisitedParlorIds(): Set<string> {
  try {
    const raw = localStorage.getItem(VISITED_PARLOR_IDS_STORAGE_KEY);
    return raw ? new Set(JSON.parse(raw)) : new Set();
  } catch {
    return new Set();
  }
}

function persistVisitedParlorIds(ids: Set<string>) {
  try {
    localStorage.setItem(VISITED_PARLOR_IDS_STORAGE_KEY, JSON.stringify(Array.from(ids)));
  } catch {
    // localStorage 접근 불가(시크릿 모드 등) - 무시
  }
}

export const useParlorDetailIsRevisit = (parlorId: string): boolean => {
  const [isRevisit, setIsRevisit] = useState(false);

  useEffect(() => {
    const visited = readVisitedParlorIds();

    if (visited.has(parlorId)) {
      setIsRevisit(true);
      return;
    }

    visited.add(parlorId);
    persistVisitedParlorIds(visited);
    setIsRevisit(false);
  }, [parlorId]);

  return isRevisit;
};
